import React from "react";
import TickList from "../tick-list/TickList";

const listItems = [
  "Read information on our <a href='https://www.johnlewis.com/customer-services/delivery-information'>delivery options and services<a/>",
  "Search <a href='https://www.johnlewis.com/customer-services/faq?q=delivery'>frequently asked questions</a> for your specific query",
];

function GeneralDeliveryQueries() {
  return (
    <div>
      <section>
        <h2>Help with delivery information and FAQs</h2>
        <p>Before getting in touch, you may wish to check the following:</p>
        <TickList squeezed items={listItems} />
      </section>
    </div>
  );
}

export default GeneralDeliveryQueries;
